import script from "./UploadFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadFiles.vue?vue&type=script&setup=true&lang=js"

import "./UploadFiles.vue?vue&type=style&index=0&id=2e14f920&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e14f920"]])

export default __exports__